import { useMutation } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";
import { showToast } from "../../../utils/ToastEmitter";
import { VERIFY_OTP_REQUEST } from "../types/RequestTypes";
import { AxiosResponse, AxiosError } from "axios";

function verifyOtpRequest({
  email,
  otp,
  firstName,
  registrationLink,
  userId,
  realm,
}: VERIFY_OTP_REQUEST): Promise<AxiosResponse<any>> {
  const reqBody = { email, params: { otp, firstName, registrationLink } };
  return fetcher({
    url: "/users/verify/otp",
    method: "POST",
    data: reqBody,
    headers: {
      "x-realm": realm,
      "x-user-id": userId?.toString(),
    },
  });
}

function useVerifyOTPMutation(cb?: (val: VERIFY_OTP_REQUEST) => void) {
  return useMutation({
    mutationFn: (params: VERIFY_OTP_REQUEST) => verifyOtpRequest(params),
    onSuccess: (data, variables) => {
      cb?.(variables);
      showToast("Authentication_Successful", "success");
    },
    onError: (error: AxiosError) => {
      console.log("error", error);
      return error?.message;
    },
  });
}

export default useVerifyOTPMutation;
